import {
  LANGUAGE_CODES,
  //  validateSpanishId
} from "@fysaro/shared";
import { z } from "zod";
import { ROLE_VALUES } from "@fysaro/domain";

export const createInvitationSchema = z
  .object({
    email: z.string().email(),
    role: z.enum(ROLE_VALUES),
    language: z.enum(LANGUAGE_CODES),
  })
  .strict();

export const acceptInvitationSchema = z.object({
  token: z.string().uuid().optional().nullable(),
  language: z.enum(LANGUAGE_CODES),
  name: z.string().min(2, "El nombre es obligatorio"),
  // identificationNumber: z.string()
  //   .trim()
  //   .toUpperCase()
  //   .regex(/^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/, "Formato inválido")
  //   .refine(validateSpanishId, "DNI no válido"),
  phone: z.string().optional().nullable(),
  specialtyId: z.string().uuid().optional().nullable(),
  password: z.string().min(6, "Mí­nimo 6 caracteres"),
  // 🌟 NUEVO: Captura de telemetrí­a también al aceptar invitaciones
  detection: z.object({
    locale: z.string().optional(),
    theme: z.string().optional(),
    timeZone: z.string().optional(),
  }).optional(),
});
